import axiosIns from '../../../../xaxios';
import {  obtenerUrlAPICalificaciones } from '../utils/funciones';
/**
 * @typedef {import('../interfaces/solicitud-modificacion-calificacion.Interfaces').FiltrosSolicitudesInterface} FiltrosSolicitudesInterface
 */
const recurso = 'calificaciones';

export default {

  async getProgramaKardex(dataInput) {
    // console.log('filtros servicio', filtros);
    // eslint-disable-next-line no-console
    console.log(dataInput);
    const {formato,programaId} = dataInput;
    const responce=formato==='pdf'?'blob':'json';
    return await axiosIns.get(obtenerUrlAPICalificaciones(`${recurso}/programa-kardex?formato=${formato}&programaId=${programaId}`), { responseType: responce });
  },

};
